import { useTheme } from '@/providers';
import MarkPulse from '../MarkPulse/MarkPulse';

export default function AppLoadingOverlay() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: isDark ? '#030712' : '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <MarkPulse size={160} color={isDark ? '#ffffff' : '#000000'} animationDuration={2} />
    </div>
  );
}
